import { setLogin } from "reduxStore/state";
import { fetchUsers } from "./userActions";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to get Authorization header
const authHeader = (getState) => ({
  Authorization: `Bearer ${getState().token}`,
  "Content-Type": "application/json",
});

export const loginUser = (values) => async (dispatch) => {
  try {
    const loggedInResponse = await fetch(`${BASE_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values),
    });
    const loggedIn = await loggedInResponse.json();

    if (loggedIn.firstTimeLogin) {
      // If firstTimeLogin is true, redirect to the password reset page
      return { firstTimeLogin: true, message: loggedIn.message };
    }

    if (!loggedIn.message) {
      dispatch(
        setLogin({
          user: loggedIn.user,
          token: loggedIn.token,
          // roles: loggedIn.roles,
        })
      );
    }

    return loggedIn;
  } catch (error) {
    // Handle any error that might occur during the login process
    console.error("Error while logging in:", error);
    return null;
  }
};

export const registerUser = (userData) => async (dispatch, getState) => {
  try {
    const res = await fetch(`${BASE_URL}/auth/register`, {
      method: "POST",
      headers: authHeader(getState),
      body: JSON.stringify(userData),
    });
    const data = await res.json();
    if (!res.ok) throw data;

    dispatch(fetchUsers());

    return { payload: data, error: null };
  } catch (err) {
    console.error("Error registering user:", err);
    return { payload: null, error: err };
  }
};

export const sendPasswordResetEmail = (email) => async (dispatch) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/initiate-password-reset`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error("Failed to send password reset email");
    }

    return true;
  } catch (error) {
    console.error("Error while sending password reset email:", error);
    return false;
  }
};

export const resetPassword = (token, password) => async (dispatch) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    });

    const result = await response.json(); // Parse the JSON response

    if (!response.ok) {
      // Handle error response and throw it so it can be caught
      throw new Error(result.message || "Failed to reset password");
    }

    return result; // On success, return the result
  } catch (error) {
    console.error("Error while resetting password:", error);
    return { success: false, message: error.message }; // Ensure that error message is propagated
  }
};
